<script>
import moment from "moment";
import axios from '@/utils/axios';
import { allUsers } from '@/utils/user';
import "daterangepicker/daterangepicker.js";
import "daterangepicker/daterangepicker.css";
import DateRangePicker from "daterangepicker";
import { permissionsMixin } from '@/mixins/userPermissions';
import StatusBadge from '@/components/common/sampling-status-badge.vue';

export default {
  inject: ['setLoading'],
  mixins: [permissionsMixin],
  components: {
   StatusBadge 
  },
  data() {
    return {
      title: "Finance & Accounts",
      text: "Finance & Accounts",
      data: [],
      users: [],
      status_data: [],
      pagination: {
       current_page: 1,
       per_page: 25,
       last_page: 1,
       total: 0,
       links: []
      },
      filter: {
       status: '', 
       to_date: '',
       from_date: '',
       search_keyword: '',
      },
      loading: false,
    };
  },

  computed: {
   text1(){
    return `Sampling Request (${this.pagination.total})`;
   }, 
   serialNo(){
    return (this.pagination.current_page - 1) * this.pagination.per_page;
   } 
  },

  mounted(){
   this.filter.status = this.$route.query.status || '';
   this.getUsers(); 
   this.loadAll();

   const start = moment().subtract(29, "days");
   const end = moment();

    new DateRangePicker(
      this.$refs.dateRangeInput,
      {
        startDate: start,
        endDate: end,
        locale: {
         format: "DD/MM/YYYY",
         separator: " - "
        },
        ranges: {
          Today: [moment(), moment()],
          Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
          "Last 7 Days": [moment().subtract(6, "days"), moment()],
          "Last 30 Days": [moment().subtract(29, "days"), moment()],
          "This Month": [moment().startOf("month"), moment().endOf("month")],
          "Last Month": [
            moment().subtract(1, "month").startOf("month"),
            moment().subtract(1, "month").endOf("month"),
          ],
        }
      },
      (start, end) => {
        this.setDateRange(start, end);
      },
      this.booking_range
    );

   this.setPermissions(this.auth);
  }, 

  methods: {

   async loadAll(){
    this.statusData();
    this.samplings();
   }, 

   async selectStatus(status){
    this.filter.status = status;
    await this.samplings();
   }, 

   async statusData(){
    try{
     const response = await axios.get(`/sampling-requests/status-wise/data`);
     this.status_data = response.data.data;
    }catch(error){
     this.$swalToast(error.message, 'error');
    }
   },     

    booking_range(start, end) {
     return start.format("DD/MM/YYYY") + " - " + end.format("DD/MM/YYYY");
    },

    setDateRange(start, end) {
     this.filter.from_date = start.format("YYYY-MM-DD");
     this.filter.to_date = end.format("YYYY-MM-DD");
    },

/* ---------------- UPDATE STATUS (WITH TRACKING) ---------------- */

async updateStatus(row) {

 const statuses = [
  { value: 'dispatched', label: 'Dispatched' },
  { value: 'delivered', label: 'Delivered' }
 ];

const { value: formValues } = await this.$swal.fire({
 title: 'Update Status',
 html: `
  <div class="mb-3 text-start">
   <label class="form-label fw-semibold">Status</label>
   <select id="statusSelect" class="form-select m-0">
    ${statuses.map(status => 
     `<option value="${status.value}" ${row.status === status.value ? 'selected' : ''}>
      ${status.label}
     </option>`
    ).join('')}
   </select>
  </div>

  <div class="mb-3 text-start">
   <label class="form-label fw-semibold">Tracking/LR Number</label>
   <input id="trackingNo" class="form-control"
    placeholder="Enter Tracking/LR number"
    value="${row.tracking_number || ''}" />
  </div>
 `,
 showCancelButton: true,
 confirmButtonText: 'Update Status',
 cancelButtonText: 'Cancel',

 preConfirm: () => {

  const status = document.getElementById('statusSelect').value;
  const tracking = document.getElementById('trackingNo').value.trim();

  if(!tracking){
   this.$swal.showValidationMessage('Please enter tracking number');
   return false;
  }

  return {
   status: status,
   tracking_number: tracking,
   id: row.id
  }

 }
});

 if(formValues){
  await this.saveStatusUpdate(formValues, row);
 }

},

/* ---------------- SAVE STATUS + TRACKING ---------------- */

async saveStatusUpdate(formValues, row) {

 this.setLoading(true);

 try{

  await axios.patch(`/sampling-requests/${formValues.id}/status/${formValues.status}`);

  if(formValues.tracking_number){
   await axios.patch(`/sampling-requests/${formValues.id}/tracking`,{
    tracking_number: formValues.tracking_number
   });
  }

  this.$swalToast('Status updated successfully!', 'success');

  await this.samplings(this.pagination.current_page);

 }catch(error){

  this.$swalToast(error.response?.data?.message || 'Failed to update status', 'error');

 }finally{

  this.setLoading(false);

 }

},

/* ---------------- OLD TRACKING FUNCTION  ---------------- */

async updateTracking(row) {
 const { value: formValues } = await this.$swal.fire({
  title: 'Update Tracking',
  html: `
   <div class="mb-3">
     <label class="form-label fw-semibold">Tracking/LR Number</label>
     <input id="trackingNo" class="form-control" placeholder="Enter Tracking/LR number" value="${row.tracking_number || ''}" />
   </div>
  `,
  showCancelButton: true,
  confirmButtonText: 'Update Tracking',
  cancelButtonText: 'Cancel',
  preConfirm: () => {
   const trackingNo = document.getElementById('trackingNo').value.trim();
         
   if(!trackingNo){
    this.$swal.showValidationMessage('Please enter tracking number');
    return false;
   }
   
   return {
    tracking_number: trackingNo,
    id: row.id
   };
 }
});

 if(formValues){
  await this.saveTrackingUpdate(formValues, row);
 }
},

async saveTrackingUpdate(formValues, row) {
 this.setLoading(true);
  try{
   await axios.patch(`/sampling-requests/${formValues.id}/tracking`, {
    tracking_number: formValues.tracking_number 
   });

   this.$swalToast('Tracking updated successfully!', 'success');

   await this.samplings(this.pagination.current_page);

  }catch(error){

   if(error.type === 'validation'){
    this.errors = error.errors;
   }else{
    this.$swalToast(error.response?.data?.message || 'Failed to update tracking', 'error'); 
   }

  }finally{

   this.setLoading(false);

  }
},

/* ---------------- USERS ---------------- */

async getUsers() {
 try{
  const response = await allUsers();
  this.users = response.data.data;
 }catch(error){
  this.$swalToast(error.message, 'error');
 }
},

/* ---------------- SAMPLING LIST ---------------- */

async samplings(page = 1) {
 this.setLoading(true);

 try{

  const params = {
   page,
   status: this.filter.status,
   to_date: this.filter.to_date,
   from_date: this.filter.from_date,
   per_page: this.pagination.per_page,
   search_keyword: this.filter.search_keyword.trim() || ''
  };

  const query_string = new URLSearchParams(params).toString();

  const response = await axios.get(`/sampling-requests?${query_string}`);

  this.data = response.data.data.data;

  this.pagination = {
   current_page: response.data.data.current_page,
   per_page: response.data.data.per_page,
   last_page: response.data.data.last_page,
   total: response.data.data.total,
   links: response.data.data.links
  };

 }catch(error){

  this.$swalToast(error.message, 'error');

 }finally{

  this.setLoading(false);

 }

},

changePage(url){
 if (!url) return;
 const page = new URL(url).searchParams.get("page");
 this.samplings(page);
},

clearFilter(){
 this.filter.status = '';
 this.filter.to_date = '';
 this.filter.from_date = '';
 this.filter.search_keyword = '';
 this.samplings();
}

  },
};
</script>

<template>
<layout-header></layout-header>
<layout-sidebar></layout-sidebar>

<!-- Page Wrapper -->
<div class="page-wrapper">
  <div class="content">
    <!-- Breadcrumb -->
    <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
      <breadcrumb :title="title" :text="text" :text1="text1" />
      <div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
        
        <!-- <div class="me-2 mb-2" v-if="pagination.total">
        <div class="dropdown">
        <a href="javascript:void(0);" class="dropdown-toggle btn btn-white d-inline-flex align-items-center" data-bs-toggle="dropdown"><i class="ti ti-file-export me-1"></i>Export
        </a>
        <ul class="dropdown-menu dropdown-menu-end p-3">
        <li><a href="javascript:void(0);" class="dropdown-item rounded-1" @click="exportFile"><i class="ti ti-file-type-xls me-1"></i>Export as Excel</a>
        </li>
        </ul>
        </div>
        </div> -->
        
        <div class="mb-2">
          <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#sampling_modal" class="btn btn-primary d-flex align-items-center" @click="$refs.samplingModal.sampling();">
            <i class="ti ti-circle-plus me-2"></i>Add Sampling Request
          </a>
        </div>
       
      </div>
    </div>
    <!-- /Breadcrumb -->

  <div class="row">

  <!-- <div class="col-md-3 cursor-pointer" v-for="(row, index) in status_data" :key="index" @click="selectStatus(row.status)">
  <div class="card flex-fill">
  <div class="card-body">
  <div class="d-flex align-items-center overflow-hidden mb-2">
   <div>
    <p class="fs-12 fw-normal mb-1 text-truncate">{{ row.status }}</p>
    <h5 class="text-muted">Total: {{ row.count }}</h5>
   </div>
  </div>
  <div class="attendance-report-bar mb-2">
    <div class="progress" role="progressbar" aria-label="Status progress" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="height: 5px;">
        <div class="progress-bar" :class="row.bg_color" :style="`width: ${row.percentage}%;`"></div>
    </div>
  </div>
  <div>
  <p class="fs-12 fw-normal d-flex align-items-center text-truncate">
   <span class="text-muted fs-12 d-flex align-items-center me-1">
    {{ row.count }} {{ row.count === 1 ? 'item' : 'items' }}
   </span>
  </p>
  </div>
  </div>
  </div>
  </div> -->
      <div class="col-xl-3 col-md-6" v-for="(row, index) in status_data" :key="index" @click="selectStatus(row.status)">
      <div class="card position-relative">
        <div class="card-body">
          <div class="d-flex align-items-center mb-3">
            <div class="">
              <p class="fw-medium text-truncate mb-1 text-capitalize">{{ row.status }}</p>
              <h5>Total: {{ row.count }}</h5>
            </div>
          </div>
          <div class="progress progress-xs mb-2" role="progressbar" aria-label="Status progress" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="height: 5px;">
            <div class="progress-bar" :class="row.bg_color" :style="`width: ${row.percentage}%;`"></div>
          </div>
          <p class="fw-medium fs-13 mb-0">
            <span class="text-muted fs-12 d-flex align-items-center me-1">
            {{ row.count }} {{ row.count === 1 ? 'item' : 'items' }}
          </span>
          </p>
          <span class="position-absolute top-0 end-0"
            ><img src="@/assets/img/bg/card-bg-04.png" alt="Img"
          /></span>
        </div>
      </div>
    </div>

  </div>    

    <div class="card">
    <div class="card-header d-flex align-items-center justify-content-center flex-wrap row-gap-3">
    <!-- <h5>Payments List</h5> -->
    
    <div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
    
    <div class="me-1" v-if="filter.search_keyword !== '' || filter.from_date !== '' || filter.to_date !== '' || filter.status !== ''">
     <a href="javascript:void(0);" class="text-danger" @click="clearFilter()"><i class="ti ti-filter-x"></i></a>
    </div>  

    <div class="me-3">
     <div class="input-icon-end position-relative">
      <input type="text" class="form-control date-range bookingrange" ref="dateRangeInput" placeholder="dd/mm/yyyy - dd/mm/yyyy">
      <span class="input-icon-addon"><i class="ti ti-chevron-down"></i></span>
     </div>
    </div>

    <div class="me-3">
        <vue-select
          v-model="filter.status"
          :options="[
            { label: 'Pending', value: 'pending' },
            { label: 'Overdue', value: 'overdue' },
            { label: 'Dispatched', value: 'dispatched' },
            { label: 'Delivered', value: 'delivered' },
          ]"
          label="label"
          :reduce="s => s.value"
          placeholder="Status"
          :clearable="true"
          @update:modelValue="samplings()"
          style="min-width: 180px;"
        ></vue-select>
      </div>

    <div class="me-3">
    <div class="input-icon-end position-relative">
     <input type="text" class="form-control" v-model="filter.search_keyword" placeholder="Search...."/>
    </div>
    </div>

    <div class="">
     <button type="button" class="btn btn-dark" @click="samplings()"><i class="ti ti-search"></i></button>
    </div>

    </div>
    
   </div>

  <div class="card-body card-table-wrapper">
    <div class="custom-datatable-filter table-responsive" v-if="data?.length">
      <table class="card-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Request No</th>
            <th>Client Name</th>
            <th>Client Phone</th>
            <th>Status</th>
            <th>Requested By</th>
            <th>Date</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in data" :key="row.id">
            <td>{{ serialNo + index + 1 }}.</td>  
            <td><a href="javascript:void(0);" class="fw-bold text-primary" data-bs-toggle="modal" data-bs-target="#sampling_detail_modal" @click="$refs.samplingModal.sampling(row);">{{ row.request_number }}</a></td>
            <td>{{ row?.party?.name }}</td>
            <td>{{ row?.party?.mobile }}</td>
            <td><StatusBadge :status="row.status"></StatusBadge></td>
            <td>
            <img v-if="row?.created_by?.image" :src="row?.created_by?.image_url" width="22" class="rounded-circle" />
            <i v-else class="ti ti-user-circle fs-18 text-muted"></i>
            {{ row?.created_by?.name }}
          </td>
            <td>{{ $formatDate(row.created_at, 'DD-MM-YYYY') }}</td>

            <td>
            <div class="dropdown" v-if="getPermission('Sampling', 'update')">
            <button class="btn btn-icon btn-sm rounded-circle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
            <i class="ti ti-dots-vertical"></i>
            </button>
            <ul class="dropdown-menu dropdown-menu-end p-3">
            <!-- <li>
            <a class="dropdown-item rounded-1" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#sampling_modal" @click="$refs.samplingModal.sampling(row)"><i class="ti ti-edit me-1"></i>Edit</a>
            </li> -->
            <li v-if="row.status !== 'delivered'">
            <a class="dropdown-item rounded-1" href="javascript:void(0);" @click="updateStatus(row)">
             <i class="ti ti-progress me-1"></i>Update Status
            </a>
            </li>
            <!-- <li v-if="row.status !== 'delivered'">
            <a class="dropdown-item rounded-1" href="javascript:void(0);" @click="updateTracking(row)">
             <i class="ti ti-truck me-1"></i>Update Tracking
            </a>
            </li> -->
            <li v-if="auth?.type === 'ADMIN'">
            <a class="dropdown-item rounded-1" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#sampling_delete_modal" @click="$refs.samplingModal.sampling(row)"><i class="ti ti-trash me-1"></i>Delete</a>
            </li>
            </ul>
            </div>  
            </td>

          </tr>
        </tbody>
      </table>

      <!-- Pagination -->
    <nav v-if="pagination.links.length > 3" class="mt-2 margin-l-2">
     <ul class="pagination pagination-sm">
      <li v-for="(link, index) in pagination.links" :key="index" :class="['page-item', { active: link.active, disabled: !link.url }]">
        <a class="page-link" href="javascript:void(0)" v-html="link.label" @click="changePage(link.url)"></a>
      </li>
     </ul>
    </nav>

    </div>

    <div v-else class="p-3 text-center text-muted"> No records found.</div>
    
  </div>
</div>
</div>

<app-footer></app-footer>

</div>
<!-- /Page Wrapper -->

<sampling-modal ref="samplingModal" @updated="loadAll()"></sampling-modal>
</template>